import _ from "lodash";
import React from "react";

import SheetPortal from "browser/components/atomic-elements/atoms/sheet/sheet-portal";
import { EntityFormBlock } from "browser/components/atomic-elements/organisms/entity/entity-form-block";
import { Entity } from "shared-libs/models/entity";
import { Footer } from "browser/components/atomic-elements/atoms/footer/footer";
import { EntityErrorBlock } from "browser/components/atomic-elements/atoms/error-block/entity-error-block";
import { Settings } from "browser/app/models/settings";

interface ICreateGateSheetProps {
  isOpen: boolean
  onClose: (entity: Entity | null) => void
  uiSchemaPath: string
  gate: Entity
  settings: Settings
}

interface ICreateGateSheetState {
  errors: any[]
}

export class CreateGateSheet extends React.Component<ICreateGateSheetProps, ICreateGateSheetState> {
  constructor(props: ICreateGateSheetProps) {
    super(props)
    this.state = { errors: [] }
  }

  public componentDidUpdate(prevProps: ICreateGateSheetProps) {
    if (prevProps.gate !== this.props.gate) {
      this.setState({ errors: [] })
    }
  }

  public render() {
    return (
      <SheetPortal
        isOpen={this.props.isOpen}
        footer={this.renderCreateGateFooter()}
        size="sm"
      >
        {this.renderGateForm()}
      </SheetPortal>
    )
  }

  private renderGateForm = () => {
    const { uiSchemaPath, gate, settings } = this.props
    const { errors } = this.state

    if (_.isEmpty(gate)) return null

    return (
      <>
        <EntityFormBlock 
          {...this.props}
          settings={settings}
          entity={gate} 
          state={{}} 
          uiSchemaPath={uiSchemaPath} 
        />
        <EntityErrorBlock entity={gate} errors={errors} />
        {/* TODO - entity error block doesn't re-render properly VD-8104 */}
      </>
    )
  }

  private renderCreateGateFooter = () => {
    return (
      <Footer
        primaryButtonText="Submit"
        onPrimaryButtonClick={this.handleCreateGate}
        onCancelButtonClick={this.onCancelButtonClick}
      />
    )
  }

  private handleCreateGate = async () => {
    const { gate } = this.props;

    try {
      await gate.save()
    } catch (e: any) {
      this.setState({ errors: e.errors })
      this.forceUpdate()
      return
    }

    this.props.onClose(null)
  }

  private onCancelButtonClick = () => {
    this.props.onClose(null)
  }
}
